import React from "react";
import PropTypes from 'prop-types';
import { TextInput } from "../../../Helpers/Inputs";
import { Row } from 'react-bootstrap';

export default function DUIConvictionForm(props) {

  const onFieldChange = (field, value) => {
    props.onChange({ ...props.formState, [field]: value })
  }

  return (
    <div key={props.index} className="mt-2">
      Conviction {props.index + 1}
      <Row className="m-0">
        <TextInput
          name={`duiConvictions[${props.index}].month`}
          id={`duiConvictions[${props.index}].month`}
          aria-label="Month"
          label="Month"
          value={props.formState.month}
          onChange={e => onFieldChange('month', e.target.value)}
          inputRef={props.register}
          errors={props.errors && props.errors.month}
          fullWidth={false}
        />
            &nbsp;
        <TextInput
          name={`duiConvictions[${props.index}].year`}
          id={`duiConvictions[${props.index}].year`}
          aria-label="Year"
          label="Year"
          value={props.formState.year}
          onChange={e => onFieldChange('year', e.target.value)}
          inputRef={props.register}
          errors={props.errors && props.errors.year}
          fullWidth={false}
        />
      </Row>
    </div>
  )
}

DUIConvictionForm.propTypes = {
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/PreQuote/steps/DUIConvictionForm.js